import { render, staticRenderFns } from "./PresentationVitaeComp.vue?vue&type=template&id=488bcd24&scoped=true"
import script from "./PresentationVitaeComp.vue?vue&type=script&lang=js"
export * from "./PresentationVitaeComp.vue?vue&type=script&lang=js"
import style0 from "./PresentationVitaeComp.vue?vue&type=style&index=0&id=488bcd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488bcd24",
  null
  
)

/* custom blocks */
import block0 from "./PresentationVitaeComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports